import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DxLookupModule } from 'devextreme-angular';
import { SeverityLevel } from '../../../framework/logging/severity-level.model';
import { lastValueFrom } from 'rxjs';
import { LoggingService } from '../../../framework/logging/logging.service';
import { ProfileDataService } from '../../services/profile-data.service';

@Component({
  selector: 'app-user-lookup',
  templateUrl: './user-lookup.component.html',
  styleUrls: ['./user-lookup.component.css'],
  standalone: true,
  imports: [DxLookupModule]
})
export class UserLookupComponent implements OnInit, AfterViewInit {

  @Output() userSelectedEmitter: EventEmitter<any> = new EventEmitter<any>();

  users: any[];
  searchEnabled: boolean = true;

  constructor(private profileDataService: ProfileDataService, private loggingService: LoggingService) {
    this.loadUserData();
  }

  async loadUserData()
  {
  try{
        const us = await lastValueFrom(this.profileDataService.getAllUsers(false));
        this.users = us[1];
    }
    catch(err)
    {
        this.loggingService.logError(err, SeverityLevel.Error);
    }
  }

  

  async ngOnInit() {

  
   
  }

  async ngAfterViewInit() {

 
   
  }

  onUserSelected(e: any)
  {
    this.userSelectedEmitter.emit(e);
  }

}
